import axios from 'axios'
import { Message } from 'element-ui'

let authRedirecting = false

function expireSession () {
  localStorage.removeItem('jjzx_token')
  localStorage.removeItem('jjzx_user')
  window.dispatchEvent(new Event('jjzx:session-expired'))
  if (authRedirecting) return
  authRedirecting = true
  Message.error('用户已失效，请重新登录')
  if (location.hash !== '#/login') location.hash = '#/login'
  setTimeout(() => { authRedirecting = false }, 1000)
}

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || 'http://localhost:8080',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
})

http.interceptors.request.use(config => {
  config.headers['X-Client-Type'] = 'PC'
  const token = localStorage.getItem('jjzx_token')
  if (token) config.headers['X-Token'] = token
  return config
})

http.interceptors.response.use(response => {
  const result = response.data && response.data.d !== undefined ? response.data.d : response.data
  if (!result || result.code !== 0) {
    const requestId = result && result.request_id ? String(result.request_id) : ''
    let message = result && result.message ? result.message : '服务响应异常'
    const authExpired = Boolean(result && result.code === 40101 && /用户已失效|登录已失效|重新登录/.test(message))
    if (authExpired) message = '用户已失效，请重新登录'
    const error = new Error(requestId ? message + '\nrequest_id: ' + requestId : message)
    error.code = result && result.code
    error.requestId = requestId
    error.authExpired = authExpired
    if (result && result.code === 40302) window.dispatchEvent(new Event('jjzx:password-change-required'))
    if (authExpired) expireSession()
    return Promise.reject(error)
  }
  return result.data
}, error => {
  const response = error && error.response
  const payload = response && response.data
  const result = payload && payload.d !== undefined ? payload.d : payload
  const serverMessage = result && typeof result === 'object' && result.message ? result.message : ''
  const message = serverMessage || (response ? `服务请求失败（HTTP ${response.status}）` : (error.message || '网络请求失败'))
  const normalized = new Error(message)
  normalized.status = response && response.status
  return Promise.reject(normalized)
})

export function asmx (service, method, payload, parameterName) {
  const body = {}
  if (parameterName) body[parameterName] = payload || {}
  return http.post('/' + service + '.asmx/' + method, body, {
    timeout: method === 'ImportDoctorMonthBase' || method === 'GetDoctorMonthBaseTemplate' ? 180000 : (method === 'AskComplianceAssistant' || method === 'AskProductKnowledge' || method === 'RefreshDoctorProfile' || method === 'GenerateAssessmentInterpretation' || method === 'RecalculateAssessmentPeriod' ? 75000 : 30000)
  })
}
